    export const UNIT_TYPE_EVENTS_OPEN_MODAL = "UNIT_TYPE_EVENTS_OPEN_MODAL";
    export const UNIT_TYPE_EVENTS_SEARCH_REQUEST = "UNIT_TYPE_EVENTS_SEARCH_REQUEST";
    export const UNIT_TYPE_EVENTS_SEARCH_RESULT = "UNIT_TYPE_EVENTS_SEARCH_RESULT";
    